import React, { useState, useEffect, useRef } from 'react';
import { RightSidebar } from './RightSidebar';
import { AnalysisPanel } from '../AnalysisPanel/AnalysisPanel';

interface ResizableLayoutProps {
    processId: string;
    AnalyseId: string;
    mapId: string;
    setShoRightPanel: React.Dispatch<React.SetStateAction<boolean>>;
}

const ResizableLayout: React.FC<ResizableLayoutProps> = ({
    processId,
    AnalyseId,
    mapId,
    setShoRightPanel,
}) => {
    const [isMaximized, setIsMaximized] = useState(false);
    const sidebarRef = useRef<HTMLDivElement>(null);

    const defaultSidebarWidth = 300;
    const minSidebarWidth = 280;
    const maxSidebarWidth = 700;

    const responsiveDefaults = {
        md: 200,
        lg: 250,
        xl: 280,
        '2xl': 500,
    };

    const [maxWidth, setMaxWidth] = useState(
        Math.floor(window.innerWidth * 0.6)
    );

    useEffect(() => {
        const handleResize = () => {
            setMaxWidth(Math.floor(window.innerWidth * 0.6));
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [initialWidth] = useState(() => {
        const width = window.innerWidth;
        if (width >= 1536) return responsiveDefaults['2xl'];
        if (width >= 1280) return responsiveDefaults.xl;
        if (width >= 1024) return responsiveDefaults.lg;
        return responsiveDefaults.md;
    });

    useEffect(() => {
        const sidebar = sidebarRef.current;
        if (!sidebar) return;

        if (isMaximized) {
            sidebar.style.width = '100vw';
            sidebar.style.maxWidth = '100vw';
            sidebar.style.minWidth = '100vw';
        } else {
            sidebar.style.width = `${initialWidth}px`;
            sidebar.style.maxWidth = `${maxWidth}px`;
            sidebar.style.minWidth = `${minSidebarWidth}px`;
        }
    }, [isMaximized, initialWidth, maxWidth]);

    return (
        <div
            ref={sidebarRef}
            className="transition-all duration-300 ease-in-out overflow-hidden"
        >
            <RightSidebar
                defaultWidth={initialWidth}
                minWidth={minSidebarWidth}
                maxWidth={maxWidth}
                isMaximized={isMaximized}
            >
                <AnalysisPanel
                    processId={processId}
                    mapId={mapId}
                    setShoRightPanel={setShoRightPanel}
                    onToggleMaximize={() => setIsMaximized((prev) => !prev)}
                    isMaximized={isMaximized}
                    AnalyseId={AnalyseId}
                />
            </RightSidebar>
        </div>
    );
};

export default ResizableLayout;
